export enum PrimarySideNavigationItemType {
  Dashboard = "Dashboard",
  Applications = "Applications",
  Consents = "Consents",
  Projects = "Projects",
  Libraries = "Libraries",
  OrganisationMembers = "OrganisationMembers",
  Profile = "Profile",
}
